import { buildModelManager } from "../builder.js";
const DefaultApprenticeResponseSelection = {
  __typename: true,
  id: true,
  completedAt: true,
  confirmRequest: true,
  content: true,
  conversationId: true,
  createdAt: true,
  errorMessage: true,
  outOfCredits: true,
  profileId: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "apprenticeResponse";
const pluralModelApiIdentifier = "apprenticeResponses";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeResponseSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "apprenticeResponseGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ApprenticeResponseManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultApprenticeResponseSelection,
  operations
);
export {
  ApprenticeResponseManager,
  DefaultApprenticeResponseSelection
};
//# sourceMappingURL=ApprenticeResponse.js.map
